import { getParam, setStorage, getStorage, isFacebookWebView } from './tools'
import Cookies from 'js-cookie';
import {AD_ID_COOKIES_KEY, IS_TOUFANG_STORE_KEY, USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY} from './constant'

// 图片地址
export const IMG_BASE_URL = 'https://static.novelfreedom.com/';
export const LOCAL_IMG_URL = IMG_BASE_URL + 'paynovel/h5-pay-asia/';
// https://static.novelfreedom.com/paynovel/h5-pay-asia/


// 获取版本号
export const getVersion = () => {
    return '1.0.4'
}

// 获取fb pixel id
export const getFbPixelId = () => {
    return APP_CONFIG[getAppID()]?.fbPixleId || APP_CONFIG['default'].fbPixleId
}


export const getPathLang = () => {
    const app = getAppID();
    return APP_CONFIG[app]?.lang || APP_CONFIG['default'].lang || 'en'
}

export const getAppID = ()=>{
    if(process.env.NODE_ENV === 'dev'){
        return 'loverflix';
    }
    let host = location.host && location.host.split('.'); 
    
    return host.length < 2 ? "" : host[host.length -2];
    // return 'almondnovel'
}

export const getShowNewPay = () => {
    const appId = getAppID();
    return ['novellettes'].includes(appId);
}

export const setCookieFbc = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
        const fbc = `fb.1.${Date.now()}.${fbclid}`;
        document.cookie = `_fbc=${encodeURIComponent(fbc)}; max-age=7776000; path=/; SameSite=Lax`;
    }
}


export const setCookieAdId = () => {
    const adId = getParam('af_ad_id') || getParam('utm_content')
    if (adId) {
        Cookies.set(AD_ID_COOKIES_KEY, adId, { expires: 365, path: '/' });
    }
}

export const APP_CONFIG = {
    wonderfulnovel: {
        fbPixleId: '571660755779128',
    },
    lucknovel: {
        fbPixleId: '571660755779128',
    },
    tintnovel: {
        fbPixleId: '1153836469730919',
    },
    slownovel: {
        fbPixleId: '1153836469730919',
    },
    colornovel:{
        fbPixleId: '1169944321513777',
    },
    lemonnovel: {
        fbPixleId: '657585096792474',
    },
    novellettes: {
        fbPixleId: '1081737203961773',
        name: 'Novellettes',
        email: 'service@novellettes.com',
        company: 'novellettes.com',
        lang: 'en'
    },
    lovernovel: {
        fbPixleId: '2872547796247341',
    },
    hawnovel: {
        fbPixleId: '1473470070734136',
        name: 'Haw Novel',
        email: 'service@novellettes.com',
        company: 'hawnovel.com',
        lang: 'en'
    },
    melonnovel: {
        fbPixleId: '697517012883450',
        name: 'Melon Novel',
        email: 'service@novellettes.com',
        company: 'melonnovel.com',
        lang: 'en'
    },
    pearnovel:{
        fbPixleId: '1207702487503898',
    },
    mangonovel:{
        fbPixleId: '1166891804789310',
    },
    lycheenovel: {
        fbPixleId: '1617161705670956',
    },
    durianovel: {
        fbPixleId: '1174264804240795',
        lang: 'en',
        company: 'durianovel.com',
        name: 'Durianovel',
        email: 'ops@novellettes.com'
    },
    pitayanovel:{
        fbPixleId: '1746737425906864',
        lang: 'en',
        company: 'pitayanovel.com',
        name: 'Pitaya Novel',
        email: 'service@novellettes.com'
    },
    papayanovel:{
        fbPixleId: '614307958167014',
        lang: 'en',
        company: 'papayanovel.com',
        name: 'Papaya Novel',
        email: 'ops@novellettes.com'
    },
    purplenovel: {
        fbPixleId: '2136930246734117',
        lang: 'en',
        company: 'purplenovel.com',
        name: 'Purple Novel',
        email: 'service@novellettes.com'
    },
    almondnovel: {
        fbPixleId: '1174264804240795',
        lang: 'kr',
        company: 'almondnovel.com',
    },
    olivenovel: {
        fbPixleId: '1174264804240795',
        lang: 'en',
        company: 'olivenovel.com',
        name: 'Olive Novel',
        email: 'service@novellettes.com'
    },
    loverflix: {
        fbPixleId: '1380939299799054',
        lang: 'en',
        company: 'loverflix.com',
        name: 'Lover Flix',
        email: 'ops@novellettes.com'
    },
    orangenovel: {
        fbPixleId: '30099358026374513',
        lang: 'en',
        company: 'orangenovel.com',
        name: 'Orange Novel',
        email: 'ops@novellettes.com'
    },
    default: {
        fbPixleId: '1081737203961773',
        moneySymbol: '$',
        lang: 'en',
        company: 'durianovel.com',
        name: 'Durianovel',
        email: 'ops@novellettes.com'
    }
}

export const getAppInfo = () => {
    const appId = getAppID()
    const obj = {
        name: APP_CONFIG[appId]?.name || APP_CONFIG['default'].name,
        company: APP_CONFIG[appId]?.company || APP_CONFIG['default'].company,
        fbPixleId: APP_CONFIG[appId]?.fbPixleId || APP_CONFIG['default'].fbPixleId,
        email: APP_CONFIG[appId]?.email || APP_CONFIG['default'].email,
    }
    return obj
}

export const isApplePayApp = () => {
    // const app = ['loverflix'];
    // return app.includes(getAppID());
    return true
}

// 是否是投放用户
export const isToufang = () => {
    return getParam('ch')
}

export function setToufang() {
    if(!getParam('ch')){
        if(isFacebookWebView()){
           const location = window.location
            let search = ''
            if(location.search){
                search = '&ch=1'
            }else{
                search = '?ch=1'
            }
            this.$router.push(`${location.pathname + location.search}${search}`)
        }
    }
}


export const setUserInfo = (id, token) => {
    Cookies.set(USER_ID_COOKIES_KEY, id, { expires: 365 })
    Cookies.set(USER_TOKEN_COOKIES_KEY, token, { expires: 365 })
    setStorage(USER_ID_COOKIES_KEY, id)
    setStorage(USER_TOKEN_COOKIES_KEY, token)
}

export const getUserInfo = () => {
    return {
        user_id: Cookies.get(USER_ID_COOKIES_KEY) || getStorage(USER_ID_COOKIES_KEY),
        user_token: Cookies.get(USER_TOKEN_COOKIES_KEY) || getStorage(USER_TOKEN_COOKIES_KEY)
    }
}